import { render, staticRenderFns } from "./ParticaArticleCurate.vue?vue&type=template&id=2e54fdc8&scoped=true&"
import script from "./ParticaArticleCurate.vue?vue&type=script&lang=ts&"
export * from "./ParticaArticleCurate.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaArticleCurate.vue?vue&type=style&index=0&id=2e54fdc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e54fdc8",
  null
  
)

export default component.exports